var map = {
	"./Videoplayer.vue": 692,
	"./app-carousel.vue": 6452,
	"./imgLoad.vue": 6614,
	"./ke-fu.vue": 4587,
	"./musicList.vue": 8635,
	"./musicScoreDetailsVIdeo.vue": 1876,
	"./payList.vue": 8690,
	"./pc-footer.vue": 9412,
	"./pc-header.vue": 2267,
	"./pc-nav.vue": 958,
	"./phone-carousel.vue": 2948,
	"./phone-footer.vue": 7403,
	"./phone-header.vue": 1407,
	"./plushing-carousel.vue": 2030,
	"./qrcode.vue": 7052
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5142;